class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      });
    } else {
      updateCartIconSection();
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      // {
      //   id: "cart-notification-button",
      // },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble-product",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
const updateCartIconSection = async () => {
  let formData = {
    sections: ["cart-icon-bubble", "cart-icon-bubble-product"],
  };

  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    const extractedHtmlContent = {};
    const parser = new DOMParser();

    for (const key in data.sections) {
      if (data.sections.hasOwnProperty(key)) {
        const htmlString = data.sections[key];

        const doc = parser.parseFromString(htmlString, "text/html");

        const mainDiv = doc.body.firstElementChild;

        if (mainDiv) {
          extractedHtmlContent[key] = mainDiv.innerHTML;
        } else {
          console.warn(`Main div not found for key: ${key}`);
          extractedHtmlContent[key] = null; // Or an empty string, depending on desired behavior
        }
      }
      if (document.querySelector(`a#${key}`)) {
        document.querySelector(`a#${key}`).innerHTML =
          extractedHtmlContent[key];
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
};
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("pageshow", (event) => {
    if (event.persisted || 1) {
      // Made it always true because some browsers do not consider it persisted if go back then go again to the same page and loaded from cache
      // If the page was loaded from the bfcache (e.g., user clicked back button)
      updateCartIconSection(); // Call the async function
    }
  });
});
updateCartIconSection();
